import { render, staticRenderFns } from "./LaborContactForm.vue?vue&type=template&id=31b918a8&scoped=true&"
import script from "./LaborContactForm.vue?vue&type=script&lang=js&"
export * from "./LaborContactForm.vue?vue&type=script&lang=js&"
import style0 from "./LaborContactForm.vue?vue&type=style&index=0&id=31b918a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b918a8",
  null
  
)

export default component.exports